import { SurveyBase } from '../base/survey.base';
import { SurveyTypeInterface } from './survey.type.interface';
import { SurveyDataInterface } from '../base/surveyData.interface';
import { SetOptions } from '@schoolbelle/common/object-change-tracker';
export class SurveyType extends SurveyBase implements SurveyTypeInterface {
  private _supportedQuestionTypes: string[] = [];
  get supportedQuestionTypes ():string[] {
    return this._supportedQuestionTypes;
  }
  get type() {
    return this.get(['type']) || 'base';
  }
  set type(v: string) {
      this.onComposeDestroy(this.type);
      this.onComposeInit(v);
      this.set(['type'], v);
  }
  constructor(survey_id: string = undefined, survey_type: string = 'base') {
    super(survey_id);
    this.init(survey_type);
  }
  /**
   *
   * @param type
   * executed within instance creation.
   * should not put any code that publish change notification system.
   */
  init(type: string) {
    this.set('type', type, { push: 'none' });
  }
  load(
    data: Partial<SurveyDataInterface> = {},
    options: SetOptions = undefined
  ) {
    //overide
    super.load({ ...data, type: this.type }, options);
  }

  onComposeInit(...args) {}
  onComposeDestroy(...args) {}
}
